import { RecordType } from '@/models.ts';

export const recordTypeLabels: Record<RecordType, string> = {
    CHLD: 'Child (CHLD)',
    FAMI: 'Family (FAMI)',
    CLEN: 'Classroom Enrollment (CLEN)',
    LANG: 'Language (LANG)',
    SLNG: 'Supplemental DLL (SLNG)',
    STFF: 'Staff (STFF)',
    SASS: 'Staff Assignment (SASS)',
    CLRM: 'Classroom (CLRM)',
    SCLR: 'Staff Classroom (SCLR)',
    ENRL: 'Enrollment (ENRL)',
    //ATTN: 'Attendance (ATTN)',
    //PRGM: 'Education Programs (PRGM)',
}

export const extractTypeLabels: Record<string, string> = {
    'CHLD': 'Child (CHLD)',
    'FAMI': 'Family (FAMI)',
    'CLEN': 'Classroom Enrollment (CLEN)',
    'LANG': 'Language (LANG)',
    'SLNG': 'Supplemental DLL (SLNG)',
    'STFF': 'Staff (STFF)',
    'SASS': 'Staff Assignment (SASS)',
    'CLRM': 'Classroom (CLRM)',
    'SCLR': 'Staff Classroom (SCLR)',
    'ENRL': 'Enrollment (ENRL)',
    //'ATTN': 'Attendance (ATTN)',
    //'PRGM': 'Education Programs (PRGM)',
    'Preschool': 'Currently active preschools',
    //'CSPPID': 'CSPPID Export',
}